import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AfgerondeWerkorders.css';
import api from '../services/api';

const DoorgestuurdeWerkorders = () => {
  const { gebruiker, logout } = useAuth();
  const navigate = useNavigate();
  const [werkorders, setWerkorders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState('ontvanger');
  const [monteurs, setMonteurs] = useState([]);
  const [planPopup, setPlanPopup] = useState(null);
  const [planDatum, setPlanDatum] = useState('');
  const [planMonteur, setPlanMonteur] = useState('');
  const [planning, setPlanning] = useState(false);

  useEffect(() => { loadWerkorders(); }, [mode]);
  useEffect(() => { api.get('/gebruikers').then(r => setMonteurs((r.data.gebruikers || []).filter(u => u.in_planning))).catch(() => {}); }, []);

  const loadWerkorders = async () => {
    setLoading(true);
    try {
      const r = await api.get(`/werkorders/doorgestuurd?mode=${mode}`);
      setWerkorders(r.data.werkorders || []);
    } catch (e) {
      console.error('Fout bij laden:', e);
    } finally {
      setLoading(false);
    }
  };

  const handleInplannen = async () => {
    if (!planDatum) return alert('Kies een datum');
    setPlanning(true);
    try {
      await api.post('/planning/plan', { werkorder_id: planPopup.id, geplande_datum: planDatum, monteur_id: planMonteur || null });
      setPlanPopup(null); setPlanDatum(''); setPlanMonteur('');
      loadWerkorders();
    } catch (err) {
      alert('Fout bij inplannen: ' + (err.response?.data?.error || err.message));
    }
    setPlanning(false);
  };

  const handleLogout = () => { logout(); navigate('/login'); };
  const getPrioriteitIcon = (p) => ({ laag: '🟢', normaal: '🟡', hoog: '🔴' }[p] || '⚪');
  const getStatusBadge = (s) => ({ nieuw: 'badge-nieuw', in_behandeling: 'badge-behandeling', afgerond: 'badge-afgerond', restwerk: 'badge-restwerk' }[s] || 'badge-default');

  const tabBtn = (active) => ({
    padding: '10px 16px',
    background: active ? '#8b5cf6' : '#e5e7eb',
    color: active ? 'white' : '#374151',
    border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 500
  });

  return (
    <div className="afgeronde-werkorders">
      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1>📤 Doorgestuurde Werkorders</h1>
          <div className="header-actions">
            <span style={{ marginRight: 16 }}>{gebruiker?.voornaam} {gebruiker?.achternaam}</span>
            <button onClick={() => navigate('/dashboard')} className="btn-back">← Dashboard</button>
            <button onClick={handleLogout} className="btn-logout">Uitloggen</button>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
          <button onClick={() => setMode('ontvanger')} style={tabBtn(mode === 'ontvanger')}>📥 Naar mij doorgestuurd</button>
          <button onClick={() => setMode('afzender')} style={tabBtn(mode === 'afzender')}>📤 Mijn doorgestuurde</button>
        </div>

        {loading ? (
          <div>Bezig met laden...</div>
        ) : werkorders.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>
            {mode === 'ontvanger' ? 'Geen werkorders naar jouw afdeling doorgestuurd.' : 'Geen werkorders door jouw afdeling doorgestuurd.'}
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: 8, overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                <th style={{ padding: 12, textAlign: 'left' }}>Titel</th>
                <th style={{ padding: 12, textAlign: 'left' }}>Status</th>
                <th style={{ padding: 12, textAlign: 'left' }}>Van</th>
                <th style={{ padding: 12, textAlign: 'left' }}>Naar</th>
                <th style={{ padding: 12, textAlign: 'left' }}>Doorgestuurd op</th>
                <th style={{ padding: 12, textAlign: 'left' }}>Door</th>
                <th style={{ padding: 12, textAlign: 'left' }}>Reden</th>
                <th style={{ padding: 12, textAlign: 'left' }}>Actie</th>
              </tr>
            </thead>
            <tbody>
              {werkorders.map(w => (
                <tr key={w.id} onClick={() => navigate(`/werkorder/${w.id}`)} style={{ cursor: 'pointer', borderBottom: '1px solid #e5e7eb' }}>
                  <td style={{ padding: 12 }}>
                    {getPrioriteitIcon(w.prioriteit)} <strong>{w.titel}</strong>
                    {w.ordernummer && <div style={{ fontSize: 12, color: '#64748b' }}>#{w.ordernummer}</div>}
                  </td>
                  <td style={{ padding: 12 }}><span className={`badge ${getStatusBadge(w.status)}`}>{w.status}</span></td>
                  <td style={{ padding: 12 }}>{w.oorspronkelijke_afdeling_naam || `afd ${w.oorspronkelijke_afdeling_id}`}</td>
                  <td style={{ padding: 12 }}>{w.afdeling_naam}</td>
                  <td style={{ padding: 12 }}>{w.doorgestuurd_op ? new Date(w.doorgestuurd_op).toLocaleString('nl-NL') : '-'}</td>
                  <td style={{ padding: 12 }}>{w.doorgestuurd_door_voornaam} {w.doorgestuurd_door_achternaam}</td>
                  <td style={{ padding: 12, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={w.doorstuur_reden || ''}>{w.doorstuur_reden || '-'}</td>
                  <td style={{ padding: 12 }} onClick={(e) => e.stopPropagation()}>
                    {w.status === 'nieuw' && (
                      <button onClick={(e) => { e.stopPropagation(); setPlanPopup(w); setPlanDatum(''); setPlanMonteur(''); }}
                        style={{ padding: '8px 14px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>📅 Inplannen</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {planPopup && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setPlanPopup(null)}>
          <div style={{ background: 'white', borderRadius: 16, padding: 28, width: 420, maxWidth: '90vw', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }} onClick={e => e.stopPropagation()}>
            <h2 style={{ fontSize: 18, color: '#1e293b', marginBottom: 4 }}>📅 Werkorder Inplannen</h2>
            <p style={{ fontSize: 13, color: '#64748b', marginBottom: 20 }}>{planPopup.titel}</p>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>Datum *</label>
              <input type="date" value={planDatum} onChange={e => setPlanDatum(e.target.value)} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14 }} />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>Monteur (optioneel)</label>
              <select value={planMonteur} onChange={e => setPlanMonteur(e.target.value)} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, background: 'white' }}>
                <option value="">-- Kies monteur --</option>
                {monteurs.map(m => <option key={m.id} value={m.id}>{m.voornaam} {m.achternaam}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setPlanPopup(null)} style={{ padding: '10px 20px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>Annuleer</button>
              <button onClick={handleInplannen} disabled={planning || !planDatum} style={{ padding: '10px 20px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600, opacity: planning || !planDatum ? 0.5 : 1 }}>{planning ? 'Bezig...' : '✅ Inplannen'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DoorgestuurdeWerkorders;
